<template>
    <PcContainer :articleId="articleId" :article="article" :prevNext="prevNext" :relatedArticles="relatedArticles" :modular="modular" :yearMonth="yearMonth" :isShare="isShare" :isArt="isArt" @onPrevNext="onPrevNext" @onRelated="onRelated" @setArticle="setArticle" />
</template>

<script setup>
import { ref, reactive, watch, computed, nextTick } from "vue";
import PcContainer from "./pc/index.vue";
import { useRoute, useRouter } from "vue-router";
import { apiFreeWeeklyArticleId, apiFreeWeeklyArticleNext, apiFreeWeeklyArticleRelated, apiFreeWeeklyModularId } from "@/request/api";
import useShareLog from "@/utils/useShareLog";
import { html2text, isEnglish, isChinese } from "@/utils";
import { ElLoading } from "element-plus";

const $route = useRoute();
const $router = useRouter();
const articleId = computed(() => $route.query.articleId); //文章id
const tagId1 = $route.query.tagId1; // 板块id1级
const keywordId = computed(() => $route.query.keywordId); // 关键词id
const modular = ref({}); // 版块信息
const relatedArticles = ref([]); // 相关文章
const article = ref({}); //文章信息
// 上一条/下一条
const prevNext = reactive({ preData: {}, nextData: {} });
// 返回的pageNum
const pageNums = reactive({
    prePage: null,
    nextPage: null,
});
const yearMonth = computed(() => {
    return {
        year: article.value.showTime?.split("-")[0],
        month: article.value.showTime?.split("-")[1],
    };
});
// 是否是分享
const isShare = computed(() => {
    return !!$route.query.share;
});
// 是否是从收藏夹过来的
const coll = computed(() => {
    return $route.query.coll === "true";
});
// 是否是分享的文章
const isArt = computed(() => {
    return $route.query.isArt === "true";
});
// 是否是搜索的文章
const isSearch = computed(() => {
    return $route.query.search === "Y";
});

// 获取版块详情
async function setModular() {
    if (tagId1 === "report") {
        modular.value = {
            tagId: "report",
            tagName: "报告",
            tagAlias: "REPORT",
        };
        return;
    }
    const { data } = await apiFreeWeeklyModularId({ tagId: tagId1 });
    modular.value = data || {};
}

// 获取文章内容
async function setArticle() {
    const loading = ElLoading.service({
        lock: true,
        text: "加载中",
        background: "rgba(0, 0, 0, 0.2)",
    });
    try {
        const { data } = await apiFreeWeeklyArticleId({ articleId: articleId.value, tagId: tagId1 });
        article.value = data || {};
        const text = html2text(article.value.articleContent);
        article.value.isEnglish = isEnglish(text); // 判断文章是否是英文
    } finally {
        nextTick(() => {
            loading.close();
        });
    }
}

// 获取上下一条
async function setPrevNext() {
    if (isArt.value || coll.value || isSearch.value) return;
    const params = { ...$route.query };
    params.startTime = localStorage.getItem("startTime");
    params.endTime = localStorage.getItem("endTime");
    const { data } = await apiFreeWeeklyArticleNext(params);
    prevNext.preData = data?.preData || {};
    prevNext.nextData = data?.nextData || {};
    pageNums.prePage = data.prePage;
    pageNums.nextPage = data.nextPage;
}

// 获取相关文章
async function setRelatedArticle() {
    if (isArt.value || coll.value || isSearch.value) return;
    const { data } = await apiFreeWeeklyArticleRelated({ articleId: articleId.value, keywordId: keywordId.value, tagId: tagId1 });
    relatedArticles.value = data || [];
}

// 跳转上下
function onPrevNext({ id, type }) {
    $router.replace({ path: `/details`, query: { ...$route.query, articleId: id, pageNum: pageNums[type] } });
}

// 跳转相关文章
function onRelated(e) {
    const routeQuery = { ...$route.query, articleId: e.articleId };
    // delete routeQuery.keywordId;
    $router.replace({ path: `/details`, query: routeQuery });
}

watch(
    () => articleId.value,
    (newVal) => {
        if (!newVal) return;
        setArticle();
        if (keywordId.value) {
            setRelatedArticle();
        } else {
            setPrevNext();
        }
    }
);

// 微信分享
// const { setShareContent } = useWxShare();

// 记录分享浏览日志
useShareLog();

setModular();
setArticle();
if (keywordId.value) {
    setRelatedArticle();
} else {
    setPrevNext();
}
</script>
